import ServiceStatementComponent from '../../../shared/ServiceStatement'
import { ServiceSettingProps } from '@/modules/Service/types'
import ViewSetting from '../../shared/ViewSetting'
import ConfigPriceRanges from '../../shared/ConfigPriceRanges'

const Statement = ({ service }: ServiceSettingProps) => {
    return (
        <>
            <ServiceStatementComponent serviceID={service?.service_id} />
            <ViewSetting
                service={service}
                peek_settings={[
                    'name',
                    'commitment_value',
                    'statementable',
                    'commitment_available',
                    'commitment_time',
                    'commitment_prepaid',
                    'commitment_price_per_unit',
                    'commitment_price_total',
                ]}
            />
            <ConfigPriceRanges
                serviceID={service?.service_id}
                show_price_list
            />
        </>
    )
}

export default Statement
